import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  height: 275px;
  width: 290px;
  margin-left: auto;
  margin-right: auto;
`

export const LoadingText = styled.h6`
  position: relative;
  bottom: ${theme.spacing.lg};

  margin: 0;
  text-align: center;
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.sm};
  line-height: ${theme.typography.lineHeight.sm};
  color: ${theme.colors.neutral.black};
`

export const LoadingTitle = styled.h1`
  margin: 0;
  text-align: center;
  font-family: ${theme.typography.family.bold};
  margin: ${theme.spacing.sm};
  font-weight: ${theme.typography.weight.md};
  font-size: ${theme.typography.sizes.lg};
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.black};
`

export const LoadingDescription = styled.p`
  margin: 0;
  text-align: center;
  font-size: ${theme.typography.sizes.sm};
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.medium};
`
